// ----------------------------------------------------------------------
// <copyright file="Izenda.YearlyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var m = require('mobx-react');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var Dropdown = require('share/components/controls/Izenda.DropDown');
  var ScheduleConstants = require('logic/data/Izenda.ScheduleConstants');
  var localizer = require('share/localization/Izenda.Localizer');

  var YearlyRecurrence = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function () {
      this.recurrence = this.props.data.yearlyRecurrencePatternSetting;
    },

    /**
    * get year input
    */
    getYear: function () {
      return this.recurrence.recurrenceYear;
    },

    /**
    * onchange year input
    */
    onChangeYear: function (input) {
      this.recurrence.recurrenceYear = input.target.value;
      this.props.data.markDirty();
    },

    /**
    * Get checked on radio
    */
    getCheckedOn: function () {
      return !this.recurrence.useOrdinalDay;
    },

    /**
    * onchange on radio
    */
    onChangeOn: function (input) {
      this.recurrence.useOrdinalDay = false;
      this.props.data.markDirty();
    },

    /**
    * Get month
    */
    getMonth: function () {
      return this.recurrence.monthValue || ScheduleConstants.MONTHNAME_LIST[0];
    },

    /**
    * Onchange month
    * @param {object} input
    */
    onChangeMonth: function (input) {
      this.recurrence.monthValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get day
    */
    getDay: function () {
      return this.recurrence.day;
    },

    /**
    * Onchange day
    * @param {object} input
    */
    onChangeDay: function (input) {
      this.recurrence.day = input.target.value;
      this.props.data.markDirty();
    },

    /**
    * Get checked on the radio
    */
    getCheckedOnThe: function () {
      return this.recurrence.useOrdinalDay;
    },

    /**
    * onchange on the radio
    * @param {object} input
    */
    onChangeOnThe: function (input) {
      this.recurrence.useOrdinalDay = true;
      this.props.data.markDirty();
    },

    /**
    * Get ordinal day
    */
    getOrdinal: function () {
      return this.recurrence.ordinalDay || ScheduleConstants.ORDINAL_LIST[0];
    },

    /**
    * Onchange ordinal day
    */
    onChangeOrdinal: function (input) {
      this.recurrence.ordinalDay = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get day name
    */
    getDayName: function () {
      return this.recurrence.ordinalDayValue || ScheduleConstants.DAYNAME_LIST[0];
    },

    /**
    * Onchange day name
    */
    onChangeDayName: function (input) {
      this.recurrence.ordinalDayValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Get month
    */
    getOrdinalMonth: function () {
      return this.recurrence.ordinalMonthValue || ScheduleConstants.MONTHNAME_LIST[0];
    },

    /**
    * Onchange month
    */
    onChangeOrdinalMonth: function (input) {
      this.recurrence.ordinalMonthValue = input.value;
      this.props.data.markDirty();
    },

    /**
    * Render component
    */
    render: function () {
      return (
        <div>
          <div className='form-group'>
            <div className='col-md-3 control-label'>{localizer.getText('SUBSCRIPTION_LABEL_RECUR_EVERY')}</div>
            <div className='col-md-1 no-padding-left'>
              <Input value={this.getYear() }
                onChange={this.onChangeYear} />
            </div>
            <div className='col-md-3 control-label no-padding-left'>{localizer.getText('SUBSCRIPTION_LABEL_YEARS')} </div>
          </div>
          <div className='form-group'>
            <div className='col-md-3'>
              <Input type='radio'
                name='yearlyRecurrence'
                checked={this.getCheckedOn() }
                onChange={this.onChangeOn} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_ON')}</span>
            </div>
            <div className='col-md-2 no-padding-left'>
              <Dropdown options={ScheduleConstants.MONTHNAME_LIST}
                value={this.getMonth() }
                onChange={this.onChangeMonth}
                disabled={this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-2 no-padding-left'>
              <Input value={this.getDay() }
                onChange={this.onChangeDay}
                disabled={this.recurrence.useOrdinalDay}/>
            </div>
          </div>
          <div className='form-group'>
            <div className='col-md-3'>
              <Input type='radio'
                name='yearlyRecurrence'
                checked={this.getCheckedOnThe() }
                onChange={this.onChangeOnThe} />
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_ON_THE')}</span>
            </div>
            <div className='col-md-2 no-padding-left'>
              <Dropdown options={ScheduleConstants.ORDINAL_LIST}
                value={this.getOrdinal() }
                onChange={this.onChangeOrdinal}
                disabled={!this.recurrence.useOrdinalDay} />
            </div>
            <div className='col-md-2 no-padding-left'>
              <Dropdown options={ScheduleConstants.DAYNAME_LIST}
                value={this.getDayName() }
                onChange={this.onChangeDayName}
                disabled={!this.recurrence.useOrdinalDay}/>
            </div>
            <div className='control-label of'>{localizer.getText('SUBSCRIPTION_LABEL_OF')}</div>
            <div className='col-md-2'>
              <Dropdown options={ScheduleConstants.MONTHNAME_LIST}
                value={this.getOrdinalMonth() }
                onChange={this.onChangeOrdinalMonth}
                disabled={!this.recurrence.useOrdinalDay} />
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = m.observer(YearlyRecurrence);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.YearlyRecurrence.jsx